<template>
  <div class="options-container">
    <div class="header">
      <h1>Opties</h1>
    </div>

    <div class="options-grid">
      <!-- Account Settings -->
      <div class="options-section">
        <h2>Account</h2>
        <div class="options-card">
          <div class="option-item" @click="router.push('/change-password')">
            <div class="option-content">
              <div class="option-title">Wachtwoord wijzigen</div>
              <div class="option-description">Wijzig het wachtwoord van uw account</div>
            </div>
            <div class="option-icon">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="icon">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';

const router = useRouter();
</script>

<style scoped>
.options-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
}

.header {
  margin-bottom: 32px;
}

.header h1 {
  font-size: 1.875rem;
  font-weight: 600;
  color: #111827;
}

.options-grid {
  display: grid;
  gap: 32px;
}

.options-section {
  background: white;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.options-section h2 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 16px;
}

.options-card {
  background: white;
  border-radius: 6px;
  overflow: hidden;
}

.option-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  cursor: pointer;
  transition: background-color 0.2s;
  border: 1px solid #E5E7EB;
}

.option-item:hover {
  background-color: #F9FAFB;
}

.option-content {
  flex: 1;
}

.option-title {
  font-weight: 500;
  color: #111827;
  margin-bottom: 4px;
}

.option-description {
  font-size: 0.875rem;
  color: #6B7280;
}

.option-icon {
  color: #9CA3AF;
  width: 20px;
  height: 20px;
  margin-left: 16px;
}

.icon {
  width: 100%;
  height: 100%;
}
</style>
